import React from 'react';

export const KeyIcon = ({
  width = '15',
  height = '15',
  'aria-hidden': ariaHidden = true,
  ...rest
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 15 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden={ariaHidden}
    {...rest}
  >
    <path
      d="M9.70461 4.41667L12.0379 2.08333M13.3713 0.75L12.0379 2.08333L13.3713 0.75ZM6.96461 7.15667C7.30884 7.49631 7.58248 7.90069 7.76978 8.34653C7.95708 8.79236 8.05434 9.27084 8.05596 9.75442C8.05758 10.238 7.96353 10.7171 7.77922 11.1642C7.59491 11.6113 7.32398 12.0175 6.98204 12.3594C6.6401 12.7014 6.23389 12.9723 5.78681 13.1566C5.33973 13.3409 4.86061 13.435 4.37703 13.4334C3.89345 13.4317 3.41497 13.3345 2.96914 13.1472C2.5233 12.9599 2.11892 12.6862 1.77928 12.342C1.11136 11.6505 0.741784 10.7243 0.750139 9.76286C0.758493 8.80147 1.14411 7.88183 1.82394 7.202C2.50377 6.52217 3.42342 6.13655 4.38481 6.1282C5.34619 6.11984 6.2724 6.48942 6.96394 7.15733L6.96461 7.15667ZM6.96461 7.15667L9.70461 4.41667L6.96461 7.15667ZM9.70461 4.41667L11.7046 6.41667L14.0379 4.08333L12.0379 2.08333L9.70461 4.41667Z"
      stroke="#344054"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
